import ServicePage from '../../components/service/ServicePage'

export default function MontageTrim() {
  return <ServicePage service="assembly" lang="de" />
}
